import React from 'react'
import Contacts from '../../components/container/contacts'
import Landing from '../../components/container/landing'
import Navbar from '../../components/container/navbar'
import About from '../../components/core-ui/about/about'
import Projects from '../../components/core-ui/projects/projects'
import Expertise from '../../components/core-ui/expertise/expertise'
import Workstyle from '../../components/core-ui/workstyle/workstyle'
import Infrastructure from '../../components/core-ui/infrastructure/infrastructure'
import Education from '../../components/core-ui/education/education'

function HomePage() {
    return (
        <div>
            <Navbar />
            <Landing />
            <About />
            <Projects />
            <Expertise />
            <Workstyle />
            <Infrastructure />
            <Education />
            <Contacts />
        </div>
    )
}

export default HomePage
